interface DinoLogoProps {
  size?: number;
  className?: string;
  showText?: boolean;
  variant?: 'icon' | 'full' | 'wordmark';
}

export function DinoLogo({ 
  size = 40, 
  className = "", 
  showText = true, 
  variant = 'full' 
}: DinoLogoProps) {
  if (variant === 'icon') {
    return (
      <img 
        src="/dino-logo.png" 
        alt="Dino" 
        width={size} 
        height={size} 
        className={className}
      />
    );
  }

  if (variant === 'wordmark') {
    return (
      <div className={`flex items-center ${className}`}>
        <span className="font-heading font-bold text-3xl tracking-tight text-foreground">
          Dino
        </span>
      </div>
    );
  }

  // Full logo with icon and text
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img 
        src="/dino-logo.png" 
        alt="Dino" 
        width={size} 
        height={size} 
      />
      {showText && (
        <span className="font-heading font-bold text-3xl tracking-tight text-foreground">
          Dino
        </span>
      )}
    </div>
  );
}

// Tagline component
export function DinoTagline({ className = "" }: { className?: string }) {
  return (
    <p className={`font-accent text-muted-foreground ${className}`}>
      Your playful reading companion 🦕
    </p>
  );
}
